import { type PropsWithChildren } from 'react';

//#region Typings
/**
 * Accepted properties for the Select DisplayValue
 * @public
 */
export type SelectV2DisplayValueProps = PropsWithChildren<unknown>;
//#endregion

/**
 * `SelectV2.DisplayValue` defines a custom display within the Trigger. A SelectV2.DisplayValue component
 * is only valid within a SelectV2.Trigger and accepts the following slots
 *
 * - SelectV2.Prefix
 * - Freeform JSX content
 *
 * @example
 * ```tsx
 * <SelectV2.DisplayValue>
 *   <SelectV2.Prefix>
 *     <WhatsNewIcon />
 *   </SelectV2.Prefix>
 *   Selected color:
 *   <Flex
 *     style={{ background: value }}
 *     width={'1rem'}
 *     height={'1rem'}
 *   />
 * </SelectV2.DisplayValue>
 * ```
 * @public
 */
export function SelectV2DisplayValue(props: SelectV2DisplayValueProps): null {
  return null;
}
